import { MDCDialog } from '@material/dialog'

export default {
  dialog: null,
  visible: false,
  setup() {
    this.dialog = new MDCDialog(this.el)
    this.dialog.focusTrap.options.skipInitialFocus = true
  },
  destroy() {
    this.dialog?.destroy()
    this.dialog = null
  },
  mounted() {
    this.setup()

    // If the dialog is tagged as blocking
    // Turn off escape key close action
    // Turn off click outside of dialog close action
    if (this.el.dataset.blocking === 'true') {
      this.dialog.escapeKeyAction = ''
      this.dialog.scrimClickAction = ''
    }

    this.dialog.listen('MDCDialog:closed', ({ detail: { action } }) => {
      this.visible = false
      this.pushEventTo(this.el, action === 'ok' ? 'ok' : 'cancel')
    })

    this.handleEvent('md-dialog-open', ({ id }) => {
      if (id !== this.el.id) return
      this.dialog.open()
      this.visible = true
      this.focusFirst()
    })

    this.handleEvent('md-dialog-close', ({ id }) => {
      if (id !== this.el.id) return
      this.dialog.close()
      this.visible = false
    })
  },
  updated: function () {
    this.visible = this.el.classList.contains('mdc-dialog--open')

    // LV controls the dialog HTML and state, when changes come in make sure the MD instance is synced
    if (this.visible) this.dialog.open()
    else this.dialog.close()
  },
  destroyed() {
    this.destroy()
  },
  focusFirst() {
    const focusableEls = Object.getPrototypeOf(
      this.dialog.focusTrap
    ).getFocusableElements(this.dialog.root)

    if (focusableEls[0] && typeof focusableEls[0] != 'undefined') {
      focusableEls[0].focus()
    }
  }
}
